<div class="revenue-comparison-table-skeleton">
  <p-table
    [value]="skeletonRows"
    [tableStyle]="{ 'min-width': '50rem' }"
    styleClass="p-datatable-sm p-datatable-striped"
    size="small"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Metric</th>
        <th class="text-center">
          <div class="column-header">
            <span class="column-title">All Revenue</span>
            <span class="column-badge all-revenue">ALL</span>
          </div>
        </th>
        <th class="text-center">
          <div class="column-header">
            <span class="column-title">Subscription</span>
            <span class="column-badge subscription">SUB</span>
          </div>
        </th>
        <th class="text-center">
          <div class="column-header">
            <span class="column-title">Non-Subscription</span>
            <span class="column-badge non-subscription">NON-SUB</span>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td class="metric-name">
          <p-skeleton width="4rem" height="1rem" />
        </td>
        <td class="metric-cell">
          <div class="metric-value-wrapper">
            <p-skeleton width="6rem" height="1.25rem" styleClass="mb-2" />
            <p-skeleton width="4rem" height="1rem" borderRadius="4px" />
          </div>
        </td>
        <td class="metric-cell">
          <div class="metric-value-wrapper">
            <p-skeleton width="6rem" height="1.25rem" styleClass="mb-2" />
            <p-skeleton width="4rem" height="1rem" borderRadius="4px" />
          </div>
        </td>
        <td class="metric-cell">
          <div class="metric-value-wrapper">
            <p-skeleton width="6rem" height="1.25rem" styleClass="mb-2" />
            <p-skeleton width="4rem" height="1rem" borderRadius="4px" />
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
